import { AccountModel, BrandsFactory, CircularProgress, GenericWrapperContext, isValidUrl, SideMenuItem, TextField, UserModel } from "@cakemail-org/ui-components-v2"
import { ChangeEvent, useContext, useEffect, useState } from "react"
import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TOnboardingFoundMatchSetup } from "./types"
import { OnboardingContext } from "../../context"
import { PUBLIC_DOMAINS } from "../../../../data/publicDomains"
import { DOMAIN_REGEX } from "../../../../data/regexes"
import { EOnboardingStep } from "../../types"

export function OnboardingFoundMatchSetup({ }: TOnboardingFoundMatchSetup) {
    const genericWrapper = useContext(GenericWrapperContext)
    const onboardingContext = useContext(OnboardingContext)
    const { t } = useTranslation()
    const [search, setSearch] = useState("")
    const [isSearchValid, setIsSearchValid] = useState(true)
    const [loading, setLoading] = useState(false)

    const enrichedPerson = onboardingContext.enrichedPerson

    useEffect(() => {
        if (!enrichedPerson?.organization?.name) {
            onboardingContext.setStep(EOnboardingStep.user)
        }
    }, [])

    function handleSearchChange(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
        setSearch(event.target.value)
    }

    function handleSearchChangeTimeout(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
        const value = event.target.value
        let isValid = isValidUrl(value) || DOMAIN_REGEX.test(value)

        if (search !== "") {
            const domain = isValid && value.startsWith('http') ? new URL(value).hostname : value

            for (const publicDomain of PUBLIC_DOMAINS) {
                if (domain === publicDomain) {
                    isValid = false
                    break
                }
            }

            setIsSearchValid(isValid)
            if (isValid) {
                setLoading(true)
                BrandsFactory.enrichOrganization({ domain }).then((res) => {
                    if (enrichedPerson && onboardingContext.step === "foundMatch") {
                        onboardingContext.setEnrichedPerson({
                            ...enrichedPerson,
                            organization: res.organization
                        })
                    }
                    setSearch("")
                    setLoading(false)
                }).catch(() => {
                    setSearch("")
                    setLoading(false)
                })
            }
        } else {
            setIsSearchValid(true)
        }
    }


    return <Stack direction="column" className={`onboardingFoundMatchSetup ${loading ? "loading" : ""}`} gap={4} flex={1}>
        <SideMenuItem
            item={{
                prefix: enrichedPerson?.organization?.logo_url ? <img key={1} src={enrichedPerson?.organization?.logo_url} alt="logo" /> : undefined,
                text: enrichedPerson?.organization?.name,
                support: enrichedPerson?.organization?.website_url?.replace(/^https?:\/\//, ''),
                name: "onboarding-link-my-org"
            }}
            variant="soloItem"
            menuItemClick={() => {
                onboardingContext.setStep(EOnboardingStep.user)
            }}
            selected={false}
        />

        <Stack direction="row" className="onboardingOrganizationSearch">
            <TextField
                name="name"
                placeholder={t("org-search-import-placeholder")}
                onChange={handleSearchChange}
                timeout={{
                    callback: handleSearchChangeTimeout,
                    time: 2000
                }}
                value={search}
                iconName="Search18"
                error={!isSearchValid}
                helperText={!isSearchValid ? t("input-validation-url-domain-error") : ""}
            />
            {loading && <CircularProgress color="secondary" size={18} />}
        </Stack>

        <SideMenuItem
            item={{
                text: t("onboarding-link-not-my-org"),
                name: "onboarding-link-not-my-org"
            }}
            variant="soloItem"
            menuItemClick={() => {

                enrichedPerson && onboardingContext.setEnrichedPerson({
                    ...enrichedPerson,
                    organization: undefined
                })
                onboardingContext.setCompanyForm(genericWrapper.account)

                onboardingContext.setIndustryForm({})

                onboardingContext.setStep(EOnboardingStep.user)
            }}
            selected={false}
        />
    </Stack>
}

export default OnboardingFoundMatchSetup